/* ============
 * Mutations for the profile module
 * ============
 *
 * The mutations that are available on the
 * profile module.
 */
import array from '@/utils/array';
import types from './mutation-types';

export default {
  [types.FETCH_ALL_USERS](state) {
    state.isUsersloading = true;
  },
  [types.FETCH_ALL_USERS_SUCCESS](state, response) {
    state.isUsersloading = false;
    state.users = response.users;
    state.totalCount = response.totalCount;
    state.userCount = response.userCount;
  },
  [types.FETCH_ALL_USER_FAIL](state, error) {
    state.isUsersloading = false;
    state.error = error;
  },
  [types.UPDATE_USER](state) {
    state.loading = true;
  },
  [types.UPDATE_USER_SUCCESS](state, response) {
    state.loading = false;
    state.user = response;
  },
  [types.UPDATE_USER_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },
  [types.CREATE_USER](state) {
    state.loading = true;
  },
  [types.CREATE_USER_SUCCESS](state, user) {
    state.loading = false;
    state.user = user;
  },
  [types.CREATE_USER_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },
  [types.FETCH_USER](state) {
    state.loading = true;
  },
  [types.FETCH_USER_SUCCESS](state, user) {
    state.loading = false;
    state.user = user;
  },
  [types.FETCH_USER_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },
  [types.RESET_USER](state) {
    state.user = {
      first_name: '',
      last_name: '',
      email: '',
      mobile_no: '',
      gender: null,
      dob: '',
      designation: null,
      address: '',
      profile_image_url: '',
      country_code: '',
      username: ''
    };
  },
  [types.DELETE_USER](state) {
    state.loading = true;
  },
  [types.DELETE_USER_SUCCESS](state, id) {
    state.loading = false;
    state.users.splice(array.findIndex(state.users, { id }), 1);
  },
  [types.DELETE_USER_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },

  [types.CHANGE_PASSWORD](state) {
    state.loading = true;
  },
  [types.CHANGE_PASSWORD_SUCCESS](state, response) {
    state.loading = false;
    state.user = response;
    state.status = 'success';
  },
  [types.CHANGE_PASSWORD_FAIL](state, error) {
    state.loading = false;
    state.error = error;
    state.status = 'danger';
  },
  [types.REQUEST_DEMO](state) {
    state.loading = true;
  },
  [types.REQUEST_DEMO_SUCCESS](state) {
    state.loading = false;
    state.isSent = true;
  },
  [types.REQUEST_DEMO_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },

};
